export const stripeRetrieveIntent = async ({ stripe, clientSecret, }) => {
    return await stripe.retrieveSetupIntent(clientSecret);
};
